angular.module('app')
  .controller('NuovoRespUtenzaCtrl', function (
    $scope,
    RichiestePostVendita,
    $transactionFactory
  ) {
    if (!$transactionFactory.get()) {
      $scope.richiestePostVendita = RichiestePostVendita.build();
    } else {
      $scope.richiestePostVendita = $transactionFactory.get();
      $transactionFactory.clear();
    }
  })
